// 대시보드 API — 계약 §7 GET /analytics/overview?days=7|30|90 (대표 전용)
import { http, data, getMeta as getInquiryMeta } from "../../inquiry/v6Api";

export const getOverview = (days) => data(http.get("/analytics/overview", { params: { days } }));
// 「지금 챙길 문의」 상태 이름(코드값 → 한글)은 문의 메타가 정본이다
export const getMeta = () => getInquiryMeta();
